import { Column } from '../models/types';

export class ColumnOrderManager {
	// 1. Для новой колонки: последний order + 10
	static getOrderForNewColumn(columns: Column[]): number {
		if (columns.length === 0) return 0;
		const lastColumn = this.sortColumnsByOrder(columns)[columns.length - 1];
		return lastColumn.order + 10;
	}

	// 2. Для вставки между колонками: среднее значение
	static getOrderBetweenColumns(prevColumn: Column | null, nextColumn: Column | null): number {
		if (!prevColumn && !nextColumn) return 0;
		if (!prevColumn) return nextColumn!.order - 10; // В начало
		if (!nextColumn) return prevColumn.order + 10;  // В конец
    
		// Если разница = 1 или меньше, нужна перевыдача
		if (nextColumn.order - prevColumn.order <= 1) {
			return -1; // Флаг для перевыдачи
		}
    
		return Math.floor((prevColumn.order + nextColumn.order) / 2);
	}

	// 3. Проверка необходимости перевыдачи
	static needsReorder(columns: Column[]): boolean {
		const sorted = this.sortColumnsByOrder(columns);
		for (let i = 1; i < sorted.length; i++) {
			if (sorted[i].order - sorted[i-1].order <= 1) {
				return true;
			}
		}
		return false;
	}

	// 4. Перевыдача order с шагом 10
	static redistributeOrders(columns: Column[]): Column[] {
		const sorted = this.sortColumnsByOrder(columns);
		return sorted.map((column, index) => ({
			...column,
			order: index * 10
		}));
	}

	// 5. Сортировка колонок по order
	static sortColumnsByOrder(columns: Column[]): Column[] {
		return [...columns].sort((a, b) => a.order - b.order);
	}

	// 6. Получение колонок для позиционирования
	static getAdjacentColumns(columns: Column[], targetIndex: number): {
    prevColumn: Column | null,
    nextColumn: Column | null
  } {
		const sorted = this.sortColumnsByOrder(columns);
    
		if (targetIndex === 0) {
			return { prevColumn: null, nextColumn: sorted[0] || null };
		}
    
		if (targetIndex >= sorted.length) {
			return { prevColumn: sorted[sorted.length - 1] || null, nextColumn: null };
		}
    
		return { 
			prevColumn: sorted[targetIndex - 1] || null,
			nextColumn: sorted[targetIndex] || null 
		};
	}
}
